import { Link } from 'react-router-dom';


const Item = ({title, img: Img}) =>{
  return(
    <div class="card w-100">
      <img
      src={Img}
      className="card-img-top"
      alt="..."
      />
      <div class="card-body d-flex flex-column">
        <h4 class="card-title font-weight-bold">
          {title}
        </h4>
        <Link
        to="/blog/details"
        className="btn btn-primary align-self-end mt-4">
          read more
        </Link>
      </div>
    </div>
  )
};
export default Item;